module.exports = __webpack_public_path__ + "static/media/chefujianglixize.1ad4b939.png";